<ng-container [ngSwitch]="filter.config.statsType">
    <ng-container *ngSwitchCase="'histogramchart'">
        <gen-histogram-chart [filter]="filter"></gen-histogram-chart>
    </ng-container>
    <ng-container *ngSwitchCase="'checkboxlist'">
        <gen-checkboxlist [filter]="filter"></gen-checkboxlist>
    </ng-container>
</ng-container>
